// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__GgBTp","insightsList":"newBusinessInsightsMenu_insightsList__2Zo-M","active":"newBusinessInsightsMenu_active__1Qwq2"};